import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TVariables } from '../../Reports/_utils/getReportVariablesForQuery'
import type { TReportStartEnd } from '../formTypesAndStyles'

const convertStartEndLocalToAPI = (modelStartEnd: TReportStartEnd | null) =>
  modelStartEnd?.startDate && modelStartEnd?.endDate
    ? { startDate: modelStartEnd.startDate, endDate: modelStartEnd.endDate }
    : null

export const convertLocalWeeklyGeneralReportToAPIFormat = (
  weeklyGeneralVariables: TVariables,
): NonNullable<
  routes.LegacyWeeklyGeneralReportsManagement.Request['legacyWeeklyGeneralReportsToCreate']
>[number] => {
  const propertyIds = (weeklyGeneralVariables.rules.propertyIds ?? []).map(Number)

  return {
    contacts: weeklyGeneralVariables.contacts.map((contactId) => ({ contactId })),
    groups: weeklyGeneralVariables.groups.map((groupId) => ({ groupId: Number(groupId) })),
    name: String(weeklyGeneralVariables.name),
    notifyOwnerByEmail: weeklyGeneralVariables.notifyOwnerByEmail,
    dayOfWeek: weeklyGeneralVariables.rules.dayOfWeek as
      'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday',
    propertyIds: propertyIds?.length ? [propertyIds[0], ...propertyIds.slice(1)] : null,
    chill: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.chill),
    evapotranspiration: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.evapotranspiration),
    fireBlight: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.fireBlight),
    growingDegreeDays: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.growingDegreeDays),
    irrigationActivity: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.irrigationActivity),
    pollination: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.pollination),
    soilMoisture: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.soilMoisture),
    weather: convertStartEndLocalToAPI(weeklyGeneralVariables.rules.weather),
    insects: Object.values(weeklyGeneralVariables.rules.pests ?? {}).flatMap((pest) => {
      if (!pest || !pest.endDate || !pest.startDate) return []

      return {
        endDate: pest.endDate,
        includeDegreeDays: Boolean(pest.degreeDays),
        includeTrapCatches: Boolean(pest.trapCatches),
        insectId: Number(pest.insectId),
        startDate: pest.startDate,
      }
    }),
  }
}
